import * as Yup from 'yup'

export const confirmationCodeSchema = Yup.object().shape({
  code: Yup.string().required('Please provide code'),
})
